<!-- <div *ngIf="gaugeArray['time'][0].length != 0"> -->
    <div echarts [options]="options" class="demo-charts" *ngIf="isTrue"></div>
<!-- </div> -->
